import { HexColorPicker } from "react-colorful";
import { Popover, Button, Box } from "@mui/material";
import React, { useState } from "react";

interface ColorPickerProps {
    color: string,
    onChange: (color: string) => void,
    blocked: boolean
}

const ColorPicker: React.FC<ColorPickerProps> = ({ color, onChange, blocked }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
        <Button
            variant="outlined"
            disabled={blocked}
            onClick={handleClick}
            sx={{
                backgroundColor: color,
                color: "#000",
                "&:hover": { backgroundColor: color },
            }}
        >
            ...
        </Button>
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <Box p={2}>
                <HexColorPicker color={color} onChange={onChange} />
            </Box>
        </Popover>
        </>
    );
};

export default ColorPicker;
